import * as React from "react";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, CampoData } from "../components/";
import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import { GetURL } from "../inar2/helpers/Policies";

interface IPolizzaListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPaginePolizzaGenerale;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class PolizzaLista extends BaseComponent<Glob.IRouteGlobaleProps, IPolizzaListaState> {
    private ParametriFissi: Dati.TListaParametri = {};
    private _ID_Anag: number = 0;
    private GraficoLimite: any;
    private GraficoUtilizzoProdotti: any;
    private Grafici: any[] = [];
    private infoContesto: Dati.InfoContesto[] = [];
    private _IdentificativoPagina: string = "Polizze e preventivi";

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;

        var M = Glob.GetMenu();
        if ((this.props.match.params as any).ID_Anag != undefined) {
            this._ID_Anag = (this.props.match.params as any).ID_Anag;
            this.ParametriFissi["ID_AnagContraente"] = this._ID_Anag.toString();
            M.ID_MenuMain = 10;
        } else {
            this._ID_Anag = 0;
            M.ID_MenuMain = 8;
        }

        M.Main = "Home";
        this.props.SetMenu(M);

        //if ((this.props.match.params as any).ID_FideAffidamento != undefined && (this.props.match.params as any).ID_FideAffidamento != null && (this.props.match.params as any).ID_FideAffidamento != "") {
        //    this.ParametriFissi["ID_FideAffidamento"] = (this.props.match.params as any).ID_FideAffidamento;
        //}

        let ParametriIniziali: Dati.TListaParametri = {};
        //ParametriIniziali["ID_TipoPolizzaStato"] = "PS-Preventivo"; Genera confusione negli utenti
        this.state = {
            Aggiornare: 1,
            Caricamento: true,
            ParamAPIPagine: Param,
            Dati: undefined,
            Parametri: this.UnisciListaParametri(ParametriIniziali, this.ParametriFissi),
            ParametriUtente: ParametriIniziali
        };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si pu� scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);
        this.OnChangeRamo = this.OnChangeRamo.bind(this);
        this.OnChangeData = this.OnChangeData.bind(this);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, "asc"];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [8],
                            orderable: false
                        }
                    ]
                });

                T.one("order.dt", (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("Polizza", this.TabellaOrdinamento[1].toUpperCase());
                                break;
                            case 1:
                                this.OnOrdinamento("StatoPolizza", this.TabellaOrdinamento[1].toUpperCase());
                                break;
                            case 2:
                                this.OnOrdinamento("TipoRamo", this.TabellaOrdinamento[1].toUpperCase());
                                break;
                            case 3:
                                this.OnOrdinamento("TipoProdotto", this.TabellaOrdinamento[1].toUpperCase());
                                break;
                            case 4:
                                this.OnOrdinamento("AnagPOS", this.TabellaOrdinamento[1].toUpperCase());
                                break;
                            case 5:
                                this.OnOrdinamento("DataEmissione", this.TabellaOrdinamento[1].toUpperCase());
                                break;
                            case 6:
                                this.OnOrdinamento("DataEffetto", this.TabellaOrdinamento[1].toUpperCase());
                                break;
                            case 7:
                                this.OnOrdinamento("DataFine", this.TabellaOrdinamento[1].toUpperCase());
                                break;
                        }
                    }
                });
            }
        }
    }

    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPaginePolizzaGenerale, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return (
                <tbody>
                    <tr>
                        <td colSpan={9} className="TextLeft alert-warning">
                            <div className="kt-alert__icon">
                                <i className="fa fa-exclamation-triangle"> </i>
                                <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            );
        } else {
            return (
                <tbody>
                    {dati.Dati.map(dato => (
                        <tr data-row="0" key={dato.Polizza}>
                            <td data-field="Polizza" className="TextLeft">
                                <a
                                    href="#"
                                    className="arrow"
                                    onClick={e => {
                                        e.preventDefault();
                                        this.props.history.push(GetURL(dato));
                                    }}
                                >
                                    {dato.Polizza}
                                </a>
                                <br />
                                {dato.Contraente}
                            </td>
                            <td data-field="Contraente" className="TextLeft">
                                {Trad.Trad(dato.StatoPolizza)}
                            </td>
                            <td data-field="Contraente" className="TextLeft">
                                {Trad.Trad(dato.TipoRamo)}
                            </td>
                            <td data-field="Contraente" className="TextLeft">
                                {((Trad.Trad(dato.TipoProdotto)).replace('- ACCELERANT', "")).replace('- MARKEL', "")}
                            </td>
                            <td data-field="Contraente" className="TextLeft">
                                {dato.AnagPOS}
                            </td>
                            <td data-field="Contraente" className="TextCenter">
                                {Trad.Trad(dato.DataEmissione)}
                            </td>
                            <td data-field="Contraente" className="TextCenter">
                                {Trad.Trad(dato.DataEffetto)}
                            </td>
                            <td data-field="Contraente" className="TextCenter">
                                {Trad.Trad(dato.DataFine)}
                            </td>
                            <td data-field="edit" className="TextCenter">
                                <a
                                    href="#"
                                    className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only"
                                    onClick={e => {
                                        e.preventDefault();
                                        this.props.history.push(GetURL(dato));
                                    }}
                                >
                                    <i className="la la-edit"></i>
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            );
        }
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return (
            <tbody>
                <tr>
                    <td colSpan={9}>{Trad.Trad("ListaErrore")}</td>
                </tr>
            </tbody>
        );
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnChangeRamo(e: string, valore?: any): any {
        this.state.ParametriUtente["ID_TipoProdotto"] = "";
        this.setState({ ParametriUtente: this.state.ParametriUtente });

        return this.OnChange(e, valore);
    }

    private OnChangeData(e: string, valore?: any): any {
        this.state.ParametriUtente["DataDa"] = "";
        this.state.ParametriUtente["DataA"] = "";
        this.setState({ ParametriUtente: this.state.ParametriUtente });

        return this.OnChange(e, valore);
    }

    public render() {
        if (!this.ControlloAutorizzazione("PolizzaController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        let ExcelLink = <div></div>;
        ExcelLink = (
            <a
                aria-current="page"
                className="kt-portlet__head-icon"
                target="_blank"
                title="Excel"
                href={"/api/Polizza/EsportaEXCEL?sessione=" + Glob.GetSessione().Sessione + "&parametri=" + JSON.stringify(this.state.ParametriUtente)}
            >
                <i className="fa fa-file-excel" style={{ color: "green" }}>
                    {" "}
                    Excel
                </i>
            </a>
        );

        return (
            <div>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <div className="kt-portlet__head-label">
                                <span className="kt-portlet__head-icon">
                                    <i className="fa fa-file"></i>
                                </span>
                                <h3 className="kt-portlet__head-label">{this._IdentificativoPagina}</h3>
                            </div>
                        </div>
                        <div className="kt-portlet__head-label">
                            <ul className="kt-portlet__head-label">
                                <div></div>
                                <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                                    {ExcelLink}
                                </div>
                            </ul>
                        </div>
                    </div>
                    <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                        <div className="kt-portlet__body">
                            <div className="form-group kt-form login-form__group row dashed-border-bottom">
                                <label className="col-lg-1 col-form-label">{Trad.Trad("Numero")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <input
                                        onChange={e => this.OnChange(e)}
                                        type="text"
                                        value={this.state.ParametriUtente["Polizza"] || ""}
                                        name="ParametriUtente[Polizza]"
                                        className="form-control kt-input"
                                        placeholder={Trad.Trad("Numero")}
                                    />
                                </div>
                                <label className="col-lg-1 col-form-label">{Trad.Trad("Ramo")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <Tipo
                                        URL={"/api/Tipi/Tipo?tabella=TipiRami&campo=TipoRamo"}
                                        Campo="ParametriUtente[ID_TipoRamo]"
                                        ID_ChiaveString={this.state.ParametriUtente["ID_TipoRamo"] || ""}
                                        OnAggiorna={this.OnChangeRamo}
                                    />
                                </div>
                                <label className="col-lg-1 col-form-label">{Trad.Trad("Prodotto")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <Tipo
                                        URL={"/api/Tipi/Tipo?tabella=TipiProdotti&campo=TipoProdotto&parametri=" + this.state.ParametriUtente["ID_TipoRamo"] || ""}
                                        Campo="ParametriUtente[ID_TipoProdotto]"
                                        ID_ChiaveString={this.state.ParametriUtente["ID_TipoProdotto"] || ""}
                                        OnAggiorna={this.OnChange}
                                    />
                                </div>
                            </div>
                            <div className="form-group kt-form login-form__group row">
                                <label className="col-lg-1 col-form-label">{Trad.Trad("Data")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <Tipo
                                        Dati={this.state.Dati != undefined ? this.state.Dati.Tipi["TipiRicercaDate"] : undefined}
                                        Campo="ParametriUtente[ID_TipiRicercaDate]"
                                        ID_ChiaveString={this.state.ParametriUtente["ID_TipiRicercaDate"] || ""}
                                        OnAggiorna={this.OnChangeData}
                                        IgnoraPermessi
                                    />
                                </div>
                                <label className="col-lg-1 col-form-label">{Trad.Trad("Da")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <div className="form-control">
                                        <CampoData
                                            ValoreInArrivo={false}
                                            Name="ParametriUtente[DataDa]"
                                            Id="ParametriUtente[DataDa]"
                                            Valore={this.state.ParametriUtente["DataDa"] || ""}
                                            OnChange={this.OnChange}
                                        />
                                    </div>
                                </div>
                                <label className="col-lg-1 col-form-label">{Trad.Trad("A")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <div className="form-control">
                                        <CampoData
                                            ValoreInArrivo={false}
                                            Name="ParametriUtente[DataA]"
                                            Id="ParametriUtente[DataA]"
                                            Valore={this.state.ParametriUtente["DataA"] || ""}
                                            OnChange={this.OnChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group kt-form login-form__group row">
                                <label className="col-lg-1 col-form-label">{Trad.Trad("Stato")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <Tipo
                                        Dati={this.state.Dati != undefined ? this.state.Dati.Tipi["PolizzaStato"] : undefined}
                                        Campo="ParametriUtente[ID_TipoPolizzaStato]"
                                        ID_ChiaveString={this.state.ParametriUtente["ID_TipoPolizzaStato"] || ""}
                                        OnAggiorna={this.OnChange}
                                        IgnoraPermessi
                                    />
                                </div>
                                <label className="col-lg-1 col-form-label">{Trad.Trad("Contraente")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <Tipo
                                        URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                        Campo="ParametriUtente[ID_AnagContraente]"
                                        ID_ChiaveString={this.state.ParametriUtente["ID_AnagContraente"] || ""}
                                        OnAggiorna={this.OnChange}
                                        TradValori
                                        LinkSelezione="/anagrafica/"
                                    />
                                </div>
                                <label className="col-lg-1 col-form-label">{Trad.Trad("POS")}</label>
                                <div className="col-lg-3 form-control-plaintext">
                                    <Tipo
                                        URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                        Campo="ParametriUtente[ID_AnagPOS]"
                                        ID_ChiaveString={this.state.ParametriUtente["ID_AnagPOS"] || ""}
                                        OnAggiorna={this.OnChange}
                                        TradValori
                                        LinkSelezione="/anagrafica/"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__foot kt-portlet__foot--fit">
                            <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                                <div className="row">
                                    <div className="col kt-form__actions kt-form__actions--center">
                                        <Bottone
                                            Default
                                            Attesa={this.state.Caricamento}
                                            OnClick={e => {
                                                this.state.ParamAPIPagine.Pagina = 1;
                                                this.setState({
                                                    Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true),
                                                    ParamAPIPagine: this.state.ParamAPIPagine,
                                                    Caricamento: true,
                                                    Aggiornare: this.state.Aggiornare + 1
                                                });
                                            }}
                                            Testo={Trad.Trad("Cerca")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
                    <div>
                        <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                            <thead>
                                <tr className="sfondoTab">
                                    <th scope="row" className="TextLeft">
                                        {Trad.Trad("Numero") + "/"}
                                    </th>
                                    <th data-field="Stato" className="TextLeft">
                                        {Trad.Trad("Stato")}
                                    </th>
                                    <th data-field="TipoRamo" className="TextLeft">
                                        {Trad.Trad("Ramo")}
                                    </th>
                                    <th data-field="TipoProdotto" className="TextLeft">
                                        {Trad.Trad("TipoProdotto")}
                                    </th>
                                    <th data-field="AnagPOS" className="TextLeft">
                                        {Trad.Trad("POS")}
                                    </th>
                                    <th data-field="DataEmissione" className="TextCenter">
                                        {Trad.Trad("DataEmissione")}
                                    </th>
                                    <th data-field="DataEffetto" className="TextCenter">
                                        {Trad.Trad("Data effetto")}
                                    </th>
                                    <th data-field="DataFine" className="TextCenter">
                                        {Trad.Trad("Data fine")}
                                    </th>
                                    <th data-field="edit" className="TextCenter">
                                        {Trad.Trad("Modifica")}
                                    </th>
                                </tr>
                            </thead>
                            <ChiamaAPI
                                Aggiornare={this.state.Aggiornare}
                                Metodo="POST"
                                URL="/api/Polizza/RicercaGenerale"
                                ParamURLClasse={this.state.ParamAPIPagine}
                                OnInvio={this.OnInvio}
                                OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
                                OnErrore={this.OnErroreLista}
                            />
                            <ChiamaAPI Aggiornare={this.state.Aggiornare} Metodo="GET" URL="/api/Tipi/Tipo?tabella=TipiRami&campo=TipoRamo" OnErrore={this.OnErroreLista} />
                            <ChiamaAPI Aggiornare={this.state.Aggiornare} Metodo="GET" URL="/api/Tipi/Tipo?tabella=TipiProdotti&campo=TipoProdotto" OnErrore={this.OnErroreLista} />
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/PolizzaLista.tsx